import type { OHLCV } from '@shared/types/candle'

import { registerIndicator } from '@/indicators/registry'
import type { IndicatorConfig, IndicatorResult } from '@/types/indicator'
import { IndicatorBase } from '@/types/indicator'

const CONFIG: IndicatorConfig = {
  id: 'ema',
  name: 'Exponential Moving Average',
  shortName: 'EMA',
  category: 'trend',
  overlay: true,
  params: [{ key: 'period', label: 'Period', type: 'number', default: 20, min: 1, max: 500 }],
  lines: [{ key: 'ema', label: 'EMA', color: '#f23645', width: 1 }],
}

class EMA extends IndicatorBase {
  readonly config = CONFIG

  calculate(candles: OHLCV[], params: Record<string, number | string | boolean>): IndicatorResult {
    const period = Math.max(1, Number(params['period']) || 20)
    const k = 2 / (period + 1)
    const values: (number | null)[] = new Array<number | null>(candles.length).fill(null)

    let ema: number | null = null
    let seedSum = 0

    for (let i = 0; i < candles.length; i++) {
      if (ema === null) {
        seedSum += candles[i].c
        if (i === period - 1) {
          ema = seedSum / period
          values[i] = ema
        }
      } else {
        ema = candles[i].c * k + ema * (1 - k)
        values[i] = ema
      }
    }

    return { lines: [{ key: 'ema', values }] }
  }
}

registerIndicator(EMA, CONFIG)
